<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { VoucherStatus } from '@/enums/VoucherStatus.js'
import { fieldValidationsMixin } from '@/mixins/fieldValidationsMixin'
import { voucherStatusMixin } from '@/mixins/voucherStatusMixin'
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'VoucherInput',
  mixins: [voucherStatusMixin, validationMixin, fieldValidationsMixin],
  validations: {
    voucher: { voucherInput: { required } }
  },
  data: () => ({
    loading: false,
    voucher: { voucherInput: '' },
    voucherStatus: '',
    submitError: false,
    showSaveNotification: false
  }),
  methods: {
    ...mapActions(['getCreditBalance']),
    //activate voucher value and returns new credit value
      async submitVoucher() {
      this.$v.$touch()
      this.submitError = false
      this.showSaveNotification = false

      if (this.$v.$invalid) {
        this.submitError = true
      } else {
        this.loading = true
        this.submitError = false
        await this.$userService
          .activateVoucher({ voucherCode: this.voucher.voucherInput })
          .then(async response => {
            await this.getCreditBalance()
            this.showSaveNotification = true
            this.voucherStatus = this.voucherStatusConfig[response]
          })
          .catch(() => {
            this.submitError = false
            this.voucherStatus = this.voucherStatusConfig[VoucherStatus.Error]
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
<template>
  <div>
    <v-card outlined>
      <v-card-title>
        <v-spacer />
        <v-row class="pl-2">
          <v-col cols="12" class="justify-center">
            <span> {{ $t('component.credit.voucher.title') }} </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle>
        <span> {{ $t('component.credit.voucher.text') }}</span></v-card-subtitle>
      <v-card-text>
        <v-row class="mb-0">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="voucher.voucherInput"
              :error-messages="fieldNeccessary($v.voucher.voucherInput, $v)"
              :label="$t('component.credit.voucher.code')"
              outlined
              required
              dense
              @input="$v.voucher.voucherInput.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn
              color="primary"
              class="text-center"
              depressed
              block
              :loading="loading"
              @click.stop="submitVoucher">
              {{ $t('component.credit.voucherInput.submit') }}</v-btn>
          </v-col>
        </v-row>
        <v-alert
          v-if="voucherStatus && showSaveNotification"
          :color="voucherStatus.color"
          class="text-center white--text">
          {{ voucherStatus.text }}
        </v-alert>
        <v-alert v-if="submitError" type="error">{{
            $t('component.credit.voucherInput.field.required') }}</v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>
